var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgService1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 61,
    viewBox: "0 0 60 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8571 4.78571V13.3571H4.28571V4.78571H12.8571ZM0 0.5V17.6429H17.1429V0.5H0ZM34.2857 11.2143V19.7857H25.7143V11.2143H34.2857ZM21.4286 6.92857V24.0714H38.5714V6.92857H21.4286ZM12.8571 30.5V39.0714H4.28571V30.5H12.8571ZM0 26.2143V43.3571H17.1429V26.2143H0Z",
    fill: "#FAFAFA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8569 17.6445V30.5017H29.9997V43.3588H17.1426V60.5017H59.9997V17.6445H42.8569ZM34.2854 34.7874H42.8569V43.3588H34.2854V34.7874ZM29.9997 56.216H21.4283V47.6445H29.9997V56.216ZM42.8569 56.216H34.2854V47.6445H42.8569V56.216ZM55.714 56.216H47.1426V47.6445H55.714V56.216ZM55.714 43.3588H47.1426V34.7874H55.714V43.3588ZM47.1426 30.5017V21.9302H55.714V30.5017H47.1426Z",
    fill: "#FAFAFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgService1);
export default __webpack_public_path__ + "static/media/service1.6f2f373637034a72969442a8643ea326.svg";
export { ForwardRef as ReactComponent };